import React, { Component } from "react"
import PropTypes from "prop-types"
import { Table } from "elemental-react16"
import { Container, Icon, Message } from "semantic-ui-react"
import Price from "components/Price/Price"
import { observer } from "mobx-react"
import shop from "shop/shop"

@observer
class CartTotal extends Component {

  componentDidMount() {
    shop.cart.update()
  }

  render() {

    let { sum, size, sumDiscount, loading } = shop.cart
    return (
      <Table style={{ maxWidth: "320px" }} className="">
        <thead>
        <tr>
          <td><strong>{translate( "Positionen" )}</strong></td>
          <td className="tr">{size}</td>
        </tr>

        <tr>
          <td><strong>{translate( "Zwischensumme" )}</strong></td>
          <td className="tr"><Price>{sum}</Price></td>
        </tr>


        <FrachtRow sum={shop.cart.sum}/>

        {(shop.session.handId && !!sumDiscount) &&
        <React.Fragment>
          <tr className={"black-60 f5"}>
            <td>{translate( "Discount" )}</td>
            <td className="tr"><Price>{sumDiscount}</Price></td>
          </tr>

          <tr>
            <td><strong>{translate( "nach Rabatt" )}</strong></td>
            <td className="tr"><Price>{sum - sumDiscount}</Price></td>
          </tr>
        </React.Fragment>
        }

        </thead>
      </Table>
    )
  }
}

CartTotal.propTypes = {
  sum : PropTypes.number,
  size: PropTypes.number,
}

@observer
export class FrachtRow extends Component {
  render() {
    let { sum } = this.props
    sum = Number(sum)
    if ( shop.session.value.country !== "IT" ) return null
    const isNorth = Number( shop.session.value.pcode ) < 70000
    let deliveryMarkup = 0
    let rate = 0

    switch ( true ) {
      case sum > 2500:
        rate = isNorth ? 0.1 : 0.15
        deliveryMarkup = rate * sum
        break;

      case sum > 1500:
        rate = isNorth ? 0.15 : 0.2
        deliveryMarkup = rate * sum
        break;

      default:
        break;
    }

    if(deliveryMarkup === 0) return null

    return <React.Fragment>
      <tr>
        <td><strong>+&nbsp;{translate( "Frachtzuschlag" )}&nbsp;({rate*100}%)</strong>
        </td>
        <td className="tr"><Price>{deliveryMarkup}</Price></td>
      </tr>
      <tr>
        <td><strong>{translate( "sum" )}</strong></td>
        <td className="tr"><Price>{sum+deliveryMarkup}</Price></td>
      </tr>

    </React.Fragment>
  }
}

FrachtRow.propTypes = { cart: PropTypes.any }

const FrachtInfo = () => {
  return <Message>
    <h3><Icon name={"info circle"}/> Frachtzuschlag</h3>
    <div>
      Auftragswert von 1.500 EUR bis 2.500 EUR <br/>
      Norditalien 15% Frachtaufschlag<br/>
      Süditalien 20% Frachtaufschlag<br/>
    </div>
    <div>
      Auftragswert größer als 2.500 EUR<br/>
      Norditalien 10% Frachtaufschlag<br/>
      Süditalien 15% Frachtaufschlag<br/>
    </div>
  </Message>
}


export default CartTotal



// WEBPACK FOOTER //
// ./src/theme/sandra/components/Cart/CartTotal.js